<template>
	<div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
		<div class="page_header">
			<span class="page_title">{{ $t('driver.驾驶评分统计') }}</span>
			<div style="flex:1;text-align: right;">
				<el-form :inline="true" size="small">
					<!-- 日/月切换单选组 -->
					<el-form-item>
						<el-radio-group v-model="tabPosition">
							<el-radio-button label="date">{{ $t('time.day') }}</el-radio-button>
							<el-radio-button label="month">{{ $t('time.month') }}</el-radio-button>
							<el-radio-button label="year">{{ $t('time.year') }}</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<!-- 日期选择器 -->
					<el-form-item>
						<el-date-picker v-model="selectedDate" :type="tabPosition"
							:placeholder="tabPosition === 'date' ? $t('龙翼简报.选择日期') : tabPosition === 'month' ? $t('龙翼简报.选择月份') : $t('龙翼简报.选择年份')"
							:format="tabPosition === 'date' ? 'yyyy-MM-dd' : tabPosition === 'month' ? 'yyyy-MM' : 'yyyy'"
							:value-format="tabPosition === 'date' ? 'yyyy-MM-dd' : tabPosition === 'month' ? 'yyyy-MM' : 'yyyy'"
							clearable size="mini"></el-date-picker>
					</el-form-item>
					<el-form-item :label="$t('driver.选择类别')" style="margin-left:30px" prop="superiorunit">
						<el-select v-model="superiorunit" :placeholder="$t('driver.请选择子公司')" clearable
							@change="selectchange">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('driver.驾驶评分') + ':'" style="margin-left:30px">
						<el-col :span="11">
							<el-input v-model="startscore" class="driving-score-input"
								@input="handleScoreInput('start')"></el-input>
						</el-col>
						<el-col class="line" :span="2"> - </el-col>
						<el-col :span="11">
							<el-input v-model="endscore" class="driving-score-input"
								@input="handleScoreInput('end')"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item style="margin-left:30px">
						<el-button type="primary" @click="onQueryClick">{{ $t('public.query') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button plain type="primary" @click="onExport">{{ $t('public.export') }}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-divider></el-divider>
		<div class="page_container">
			<!-- 顶部统计卡片 -->
			<div style="margin-bottom: 20px;">
				<el-row :gutter="20">
					<el-col :span="12" style="width: 20%;">
						<div style="background: #FFFFFF;border-radius: 4px;border: 1px solid #B5C4DF;padding:20px;">
							<div style="display: flex;justify-content: space-between;align-items: center;">
								<div style="flex:1;color: #0F1A3A;font-size: 14px;">{{ $t('driver.总览') }}</div>
								<div style="text-align: right;">
									<el-rate :value="calculateStar(totalshow.TotalScore)" disabled :max="5" allow-half
										:colors="['#2A7AFF', '#2A7AFF', '#2A7AFF']"></el-rate>
								</div>
							</div>
							<div style="margin-top: 15px;display: flex;align-items: center;">
								<div style="font-size: 24px;font-weight: bold;color: #0F1A3A;">{{ totalshow.TotalScore
								}}
								</div>
								<div :style="{ color: totalshow.CompareValue > 0 ? '#FF106E' : '#00B42A' }"
									style="font-size: 14px;margin-left: 8px;">
									{{ totalshow.CompareValue > 0 ? '+' + totalshow.CompareValue :
										totalshow.CompareValue }}
								</div>
							</div>
						</div>
					</el-col>
					<!-- 安全性 -->
					<el-col :span="12" style="width: 20%;">
						<score_item type="safety" :score="totalshow.Safety" :compare-value="totalshow.Safety" />
					</el-col>
					<!-- 经济性 -->
					<el-col :span="12" style="width: 20%;">
						<score_item type="economy" :score="totalshow.Economy" :compare-value="totalshow.Economy" />
					</el-col>
					<!-- 舒适性 -->
					<el-col :span="12" style="width: 20%;">
						<score_item type="comfort" :score="totalshow.Comfort" :compare-value="totalshow.Comfort" />
					</el-col>
					<!-- 护车性 -->
					<el-col :span="12" style="width: 20%;">
						<score_item type="vehicleCare" :score="totalshow.VehicleCare"
							:compare-value="totalshow.VehicleCare" />
					</el-col>
				</el-row>
			</div>


			<div style="width: 100%;">
				<!--图表显示-->
				<div ref="scoreChart" style="height: 400px;margin-top: 15px;margin-bottom: 15px; width: 100%;"></div>
			</div>
			<el-divider></el-divider>
			<!-- 数据表格 -->
			<el-table :data="tableData" border style="width: 100%" size="small" v-loading="loading" ref="scoreTable">
				<el-table-column prop="Rank" :label="$t('driver.排名')" align="center" />
				<el-table-column prop="CarNo" :label="$t('runState.carNo')" align="center" />
				<el-table-column prop="TheDate" :label="$t('statistics.statisticalTime')" align="center" />
				<el-table-column prop="TotalScore" :label="$t('driver.驾驶评分')" align="center" />
				<el-table-column :label="$t('driver.star')" align="center" width="180px">
					<template slot-scope="scope">
						<el-rate :value="calculateStar(scope.row.TotalScore)" disabled :max="5" allow-half
							:colors="['#2A7AFF', '#2A7AFF', '#2A7AFF']"></el-rate>
					</template>
				</el-table-column>
				<el-table-column prop="Safety" :label="$t('driver.安全性')" align="center" />
				<el-table-column prop="Economy" :label="$t('driver.经济性')" align="center" />
				<el-table-column prop="Comfort" :label="$t('driver.舒适性')" align="center" />
				<el-table-column prop="VehicleCare" :label="$t('driver.护车性')" align="center" />
				<el-table-column :label="$t('public.Operation')" align="center">
					<template slot-scope="scope">
						<el-button type="text" @click="handleDetail(scope.row)">{{ $t('public.Detail') }}</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total"
				@current-change="pageChange" :current-page.sync="form.PageNo"></kl-pagination>
			<div style="height: 15px;"></div>

		</div>

		<!-- 详情弹窗 -->
		<el-dialog :visible.sync="outerVisible" append-to-body fullscreen :show-close="false">
			<detail @onClose="outerVisible = false" :carNo="carNo" v-bind:dataTypes="dataTypes"
				:totalMileage="totalMileage" :totalScore="totalScore" :totalTime="totalTime"
				v-bind:traceData="traceData" />
		</el-dialog>
	</div>
</template>

<script>
import score_item from "./components/score_item"
import detail from "./detail"
import settings from "@/settings";
import {
	mapState
} from 'vuex';


import language from '@/utils/getLanguageId';

export default {
	name: "drivingStatistics",
	components: {
		score_item,
		detail
	},
	data() {
		return {
			outerVisible: false,
			tabPosition: 'date', // 默认按日查询
			level: 4,
			loading: false, // 表格加载状态
			form: {
				PageNo: 1, // 当前页码
				PageSize: 10 // 每页条数
			},
			tableData: [],
			allTableData: [],
			total: 4,
			// 日期相关核心变量
			selectedDate: '', // 日期选择器绑定值
			beginTime: '', // 接口请求的开始时间
			endTime: '', // 接口请求的结束时间
			totalshow: {
				TotalScore: 0, // 总览评分
				CompareValue: 0, // 比较值（所有卡片共用）
				Safety: 0, // 安全性评分
				Economy: 0, // 经济性评分
				Comfort: 0, // 舒适性评分
				VehicleCare: 0 // 护车性评分
			},
			carNo: "",
			dataTypes: [],
			totalMileage: 0.0,
			totalScore: 0.0,
			totalTime: "",
			traceData: [],
			superiorunit: "",
			options: [],
			startscore: "0",
			endscore: "100",
			LanguageId: 1,
			barChart: null, // 图表实例引用
		}
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizeChart);
		if (this.barChart) {
			this.barChart.dispose();
		}
	},
	activated() {
		// 组件激活时重新初始化图表
		this.resizeChart();
	},
	computed: {
		size() {
			return this.$store.getters.size
		},
		...mapState({
			operator: state => state.user.operator,
			vehicles: state => state.app.vehicles,
			selectedVehicles: state => state.app.vehicles.selectedVehicles,
		}),
		selectedVehicleIds() {
			const vehicleIds = this.selectedVehicles
				.filter(item => item.treeLevel === 5)
				.map(item => item.nodeValue);
			return vehicleIds.join(',') || '';
		},
	},
	watch: {
		allTableData: {
			handler() {
				if (this.barChart) {
					this.updateBarChart();
				}
			},
			deep: true
		},
		// 切换日/月时，自动更新日期并查询
		tabPosition: {
			handler() {
				this.initDefaultDate();
				this.setTimeRange();
				this.onQueryClick(); // 切换后自动查询
			},
			immediate: true
		},
		// 手动选择日期/月份后，自动查询
		selectedDate() {
			this.setTimeRange();
			this.onQueryClick(); // 选择日期后自动查询
		}
	},
	mounted() {
		const currentPath = this.$route.path
		// 从全局变量中取出对应路由的开始时间
		const startTime = settings.routeStartTime[currentPath]
		if (startTime) {
			// 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
			const renderTime = Date.now() - startTime
			console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
			// 可选：上报到后端或日志系统
			// reportRenderTime(currentPath, renderTime)

			// 清除已计算的开始时间，避免重复计算
			delete settings.routeStartTime[currentPath]
		}
		this.$store.dispatch("app/closeSideBar");
		this.LanguageId = language(this.$store.getters.locale)
		// 1. 先初始化日期参数（确保beginTime/endTime有值）
		this.initDefaultDate();
		// 2. 获取子公司下拉数据，完成后执行首次查询
		this.$nextTick(() => {
			this.initBarChart();
		});
		this.$api
			.queryBranchInfo({
				companyID: this.operator.CompanyId
			})
			.then((res) => {
				if (res && res.code === 200) {
					this.options = res.data.map(item => ({
						value: item.branchofficeID,
						label: item.branchname,
					}));
				}
				// 首次查询：确保时间和下拉数据都就绪
				this.onQueryClick();
			})
			.catch(err => {
				console.error('获取子公司数据失败：', err);
				// 即使子公司数据加载失败，仍执行查询（避免页面空白）
				this.onQueryClick();
			});

		window.addEventListener('resize', this.resizeChart);
	},
	methods: {
		updateBarChart() {
			this.barChart.setOption({
				xAxis: {
					data: this.allTableData.map(item => item.CarNo)
				},
				series: [
					{
						data: this.allTableData.map(item => item.TotalScore)
					}
				]
			});
		},
		resizeChart() {
			if (this.barChart) {
				this.barChart.resize();
			}
		},
		initBarChart() {

			const chartDom = this.$refs.scoreChart;
			this.barChart = echarts.init(chartDom);


			const option = {
				title: {
					text: this.$t('driver.驾驶评分'),
					left: 'left',
					textStyle: {
						fontSize: 12,
						fontWeight: '400',
						color: '#0F1A3A'
					}
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow',
						shadowStyle: {
							color: 'rgba(42, 122, 255, 0.1)'
						}
					},
					backgroundColor: 'rgba(255, 255, 255, 0.95)',
					borderColor: '#e6e6e6',
					borderWidth: 1,
					textStyle: {
						color: '#333'
					},
					extraCssText: 'box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15)',
					formatter: (params) => {
						const data = params[0];
						return `
      <div style="padding: 8px;">
        <div style="font-weight: bold; margin-bottom: 4px;">${data.name}</div>
        <div style="color: #0F1A3A;"><span style="width: 8px;height: 8px;background: #2A7AFF;border-radius: 2px;display: inline-block;margin-right:5px"></span>${data.seriesName}: ${data.value}</div>
        <div style="color: #0F1A3A; margin-top: 4px;"><span style="width: 8px;height: 8px;background: #2A7AFF;border-radius: 2px;display: inline-block;margin-right:5px"></span>${this.$t('driver.star')}: ${this.calculateStar(data.value)}</div>
      </div>
    `;
					}
				},
				legend: {
					data: [this.$t('driver.驾驶评分')],
					bottom: 10,
					textStyle: {
						fontSize: 12,
						color: '#666'
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '15%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: this.allTableData.map(item => item.CarNo),
					axisLabel: {
						rotate: 0,
						interval: 0,
						fontSize: 11,
						color: '#666', formatter: (value) => {
							// 只显示部分车牌号
							return value.length > 6 ? value.substring(0, 6) + '...' : value;
						}
					},
					axisLine: {
						lineStyle: {
							color: '#e6e6e6'
						}
					},
					axisTick: {
						show: false
					}
				},
				yAxis: {
					type: 'value',
					min: 0,
					max: 100,
					axisLabel: {
						formatter: '{value}',
						fontSize: 11,
						color: '#666'
					},
					axisLine: {
						lineStyle: {
							color: '#e6e6e6'
						}
					},
					splitLine: {
						lineStyle: {
							color: '#f5f5f5',
							type: 'dashed'
						}
					}
				},
				dataZoom: [
					{
						type: 'inside',
						start: 0,
						end: 100,
						zoomLock: false
					},
					{
						show: true,
						type: 'slider',
						bottom: 5,
						start: 0,
						end: 100,
						height: 20,
						borderColor: '#e6e6e6',
						backgroundColor: '#fafafa',
						fillerColor: 'rgba(42, 122, 255, 0.2)',
						handleStyle: {
							color: '#2A7AFF',
							borderColor: '#2A7AFF'
						}
					}
				],
				series: [
					{
						name: this.$t('driver.驾驶评分'),
						type: 'bar',
						data: this.allTableData.map(item => item.TotalScore),
						barWidth: 15,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#409EFF' },
								{ offset: 1, color: '#2A7AFF' }
							]),
							borderRadius: [4, 4, 0, 0]
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: '#66B1FF' },
									{ offset: 1, color: '#409EFF' }
								])
							}
						},
						label: {
							show: true,
							position: 'top',
							fontSize: 10,
							color: '#666'
						}
					}
				]
			};

			this.barChart.setOption(option);
		},
		// 初始化默认日期
		initDefaultDate() {
			const today = new Date();
			if (this.tabPosition === 'date') {
				// 按日：格式 yyyy-MM-dd
				this.selectedDate =
					`${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate() - 1).padStart(2, '0')}`;
			} else if (this.tabPosition === 'month') {
				// 按月：格式 yyyy-MM
				this.selectedDate = `${today.getFullYear()}-${String(today.getMonth()).padStart(2, '0')}`;
			} else if (this.tabPosition === 'year') {
				// 按年：格式 yyyy
				this.selectedDate = `${today.getFullYear()}`;
			}
			// 手动触发一次时间范围计算
			this.setTimeRange();
		},

		// 计算星级
		calculateStar(score) {
			// 处理异常值：评分<0按0算，>100按100算
			const validScore = Math.max(0, Math.min(100, Number(score) || 0));

			// 星级对应规则
			if (validScore >= 90) return 5;
			if (validScore >= 80) return 4.5;
			if (validScore >= 70) return 4;
			if (validScore >= 60) return 3.5;
			if (validScore >= 50) return 3;
			if (validScore >= 40) return 2.5;
			if (validScore >= 30) return 2;
			if (validScore >= 20) return 1.5;
			if (validScore >= 10) return 1;
			if (validScore > 0) return 0.5;
			return 0; // 0分时返回0星
		},

		// 设置时间范围
		setTimeRange() {
			if (!this.selectedDate) return;

			const selected = new Date(this.selectedDate);
			if (this.tabPosition === 'date') {
				// 按日：开始/结束时间 = 选中日期
				this.beginTime = this.selectedDate;
				this.endTime = this.selectedDate;
			} else if (this.tabPosition === 'month') {
				// 按月：开始时间=当月1号，结束时间=当月最后一天
				const firstDay = new Date(selected.getFullYear(), selected.getMonth(), 1);
				const lastDay = new Date(selected.getFullYear(), selected.getMonth() + 1, 0);
				// 格式化到日
				this.beginTime =
					`${firstDay.getFullYear()}-${String(firstDay.getMonth() + 1).padStart(2, '0')}-${String(firstDay.getDate()).padStart(2, '0')}`;
				this.endTime =
					`${lastDay.getFullYear()}-${String(lastDay.getMonth() + 1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`;
			} else if (this.tabPosition === 'year') {
				// 按年：开始时间=当年1月1日，结束时间=当年12月31日
				this.beginTime = `${selected.getFullYear()}-01-01`;
				this.endTime = `${selected.getFullYear()}-12-31`;
			}
		},

		// 详情弹窗
		handleDetail(row) {
			this.outerVisible = true;
			this.carNo = row.CarNo;
			this.dataTypes = [];
			this.totalMileage = 0.0;
			this.totalScore = 0.0;
			this.totalTime = "";
			this.traceData = [];
			let newvehicle = this.vehicles.data.filter((item) => {
				return item.treeLevel == 5
			})

			newvehicle.forEach((item) => {
				if (item.vehicleName == row.CarNo) {
					row.VID = item.nodeValue;
				}
			});

			this.$api.queryWebDrivingScoreTrip({
				OperatorID: this.operator.OperatorId.toString(),
				VehicleIDs: row.VID.toString(),
				BeginTime: this.beginTime + " " + "00:00:00",
				EndTime: this.endTime + " " + "23:59:59",
			}).then(res => {
				this.loading = false;
				if (res.code === 200) {
					this.dataTypes = res.TripRec.map(item => ({
						...item,
						VehicleIDs: row.VID
					})) || [];
					this.totalMileage = res.TotalMileage;
					this.totalScore = res.TotalScore;
					this.totalTime = row.TheDate;
					this.traceData = Array.isArray(res.TraceData) ? res.TraceData : [];
				}
			}).catch(err => {
				this.loading = false;
				this.$message.error(this.$t('路费.接口请求失败'));
				this.traceData = [];
				console.error('查询错误：', err);
			});
		},

		// 选择类别变化
		selectchange(val) {
			console.log(val);
		},

		// 分页切换
		pageChange(page) {
			this.form.PageNo = page;
			this.onQuery();
		},
		onQueryClick() {
			this.onQuery();
			//获取所有数据
			this.$api.queryWebDrivingScore({
				OperatorID: this.operator.OperatorId.toString(),
				VehicleIDs: this.selectedVehicleIds,
				BeginTime: this.beginTime,
				EndTime: this.endTime,
				PageNo: 1,
				PageSize: 65535,
				GroupID: this.superiorunit,
				MinScore: this.startscore,
				MaxScore: this.endscore,
				Flag: this.tabPosition === "date" ? 1 : this.tabPosition === "month" ? 0 : 2,
				IsExport: 0 //1为下载 0 为查询
			}).then(res => {
				//	console.log(res)
				this.allTableData = res.VehicleScore;
				//清空
				//this.allTableData = [];
				//随机生成100条数据插入到allTableData

				// this.allTableData.push(...Array.from({ length: 20 }, (_, i) => ({
				// 	CarNo: `车辆${i + 1}`,
				// 	TotalScore: Math.floor(Math.random() * 101),
				// 	// TheDate: this.selectedDate
				// })));


			}).catch(err => {
				// console.log(err)
			});
		},

		// 导出表格数据
		onExport() {
			var that = this;
			if (that.tableData.length === 0) {
				that.$message.warning(this.$t('public.noData'));
				return;
			}

			that.$api
				.queryWebDrivingScore({
					OperatorID: that.operator.OperatorId.toString(),
					VehicleIDs: that.selectedVehicleIds,
					BeginTime: that.beginTime,
					EndTime: that.endTime,
					PageNo: that.form.PageNo,
					PageSize: that.form.PageSize,
					GroupID: that.superiorunit,
					MinScore: that.startscore,
					MaxScore: that.endscore,
					Flag: that.tabPosition === "date" ? 1 : that.tabPosition === "month" ? 0 : 2,
					IsExport: 1, //1为下载 0 为查询
					Language: this.$store.getters.LanguageId,//语言id
				}, "blob")
				.then((res) => {

					// console.log(res)
					let blob = new Blob([res], {
						type: "application/vnd.ms-excel;charset=utf-8"
					}); // 重点代码
					let a = document.createElement("a");
					a.href = window.URL.createObjectURL(blob);
					a.setAttribute("download", this.$t('driver.驾驶评分统计') +
						`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
					a.click(); // 执行下载
					window.URL.revokeObjectURL(blob); // 释放ur
				}).catch((error) => {

					// that.downloading = false;
					console.error("下载失败", error);
				});
		},
		//时间戳转换为日期格式
		timestampToTime(timestamp) {
			var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
			var Y = date.getFullYear();
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
			var D = date.getDate();
			var h = date.getHours();
			var m = date.getMinutes();
			var s = date.getSeconds();
			return Y + M + D + h + m + s;
		},
		// 处理评分输入
		handleScoreInput(type) {
			let inputValue = type === 'start' ? this.startscore : this.endscore;
			// 过滤非数字字符（只保留数字）
			const numericValue = inputValue.replace(/[^\d]/g, '');
			// 转换为数字（空字符串则设为0）
			let num = numericValue === '' ? 0 : Number(numericValue);

			if (type === 'start') {
				// 起始分规则：最小0，最大不超过结束分
				const maxStart = this.endscore ? Number(this.endscore) : 100;
				this.startscore = Math.max(0, Math.min(num, maxStart)).toString();
			} else {
				// 结束分规则：最小不小于起始分，最大100
				const minEnd = this.startscore ? Number(this.startscore) : 0;
				this.endscore = Math.max(minEnd, Math.min(num, 100)).toString();
			}
		},

		// 查询逻辑
		onQuery(isExport = false) {
			if (this.loading) return;
			var that = this;

			that.loading = true;// !isExport; // 导出时不显示加载状态
			that.$api.queryWebDrivingScore({
				OperatorID: that.operator.OperatorId.toString(),
				VehicleIDs: that.selectedVehicleIds,
				BeginTime: that.beginTime,
				EndTime: that.endTime,
				PageNo: that.form.PageNo,
				PageSize: that.form.PageSize,
				GroupID: that.superiorunit,
				MinScore: that.startscore,
				MaxScore: that.endscore,
				Flag: that.tabPosition === "date" ? 1 : that.tabPosition === "month" ? 0 : 2,
				IsExport: 0 //1为下载 0 为查询
			}).then(res => {
				that.loading = false;
				// console.log(res)
				if (res.VehicleCount > 0) {
					that.tableData = res.VehicleScore;
					that.total = res.VehicleCount;
					if (!res.GeneralScore.compareValue) {
						res.GeneralScore.compareValue = 0;
					}
					that.totalshow = res.GeneralScore;
					//that.totalshow.compareValue 不能为 null,否则会导致比较值为 null
					//判断是否为 undefined

					console.log(that.totalshow.compareValue);



					that.traceData = Array.isArray(res.TraceData) ? res.TraceData : [];
					if (that.total === 0 && !isExport) {
						that.$message.info(that.$t("statistics.noData"));
					}

				} else {
					that.tableData = [];
					that.total = 0;
					that.totalshow = {
						TotalScore: 0, // 总览评分
						CompareValue: 0, // 比较值（所有卡片共用）
						Safety: 0, // 安全性评分
						Economy: 0, // 经济性评分
						Comfort: 0, // 舒适性评分
						VehicleCare: 0 // 护车性评分
					};
					// this.$message.error('数据加载失败：' + (res.message || ''));

				}
			}).catch(err => {
				this.loading = false;
				this.$message.error(this.$t('路费.接口请求失败'));
				console.error('查询错误：', err);

			});

		}
	}
}
</script>
<style lang="scss" scoped>
::v-deep .el-input__inner {
	font-size: 12px;
	width: 130px;
}

::v-deep.el-date-editor.el-input,
.el-date-editor.el-input__inner {
	width: 130px;
}


/* 星级评分样式调整 */
::v-deep .el-rate__item {
	margin-right: -6px !important;
}

::v-deep .driving-score-input .el-input__inner {
	width: 70px !important;
}
</style>